import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    provinceCode: [],
    isCollapse: false,
    selectedMenu:'',
    selectData: [], // 列表选择
    setIntervalFlag:null,
    tabsList: [
    ],
    industrie:[],
    companyId:0
  },
  mutations: {
    saveTabsData(state, data) {
      state.tabsList = data ? JSON.parse(data) : []
      sessionStorage.setItem('tabs', data)
    },
    // 表格获取选中数据
    getSelectData(state, payload) {
      state.selectData = payload;
    },
    isCollapseFlag(state, payload) {
      state.isCollapse = payload;
    },
    getSelectMenuFlag(state, payload) {
      state.selectedMenu = payload;
    },
    getProvinceList(state, payload) {
      state.provinceCode = payload;
    },
    getIndustrie(state,payload){
      state.industrie=payload;
    },
    setCompanyId(state,payload){
      state.companyId=payload;
    }, 
  },
  actions: {
    // 获取城市省市区ID
    getOptions({
      commit
    }, that) {
      axios
        .get(that.$api.Business.provinceCode, true)
        .then((res) => {
          // console.log("城市", res);
          let data = JSON.parse(res.data.data);
          commit("getProvinceList", data);
        })
        .catch((err) => {
          console.log("失败");
        });
    },
    
  },
  modules: {},
});